import { render, staticRenderFns } from "./Facturas.vue?vue&type=template&id=18146222"
import script from "./Facturas.vue?vue&type=script&lang=js"
export * from "./Facturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports